import { environment } from '../../../environment/environment.js';

export class DebugService {
  classname: string;
  blnDebug = !environment.isProdEnv;
  blnHasConsole = true;
  defaultClassname = 'No Classname::';

  constructor(className: string) {
    this.classname = className + '::';
    if (className.lastIndexOf('::') === className.length - 2) {
      this.classname = className;
    }
  }

  log(pMessage, pObject?, debugType = 'info'): void {
    if (this.classname === null || this.classname === undefined) {
      this.classname = this.defaultClassname;
    }
    if (this.blnDebug && this.checkForConsole()) {
      const time = new Date();
      const timestr =
        ('0' + time.getHours()).slice(-2) +
        ':' +
        ('0' + time.getMinutes()).slice(-2) +
        ':' +
        ('0' + time.getSeconds()).slice(-2);
      if (pObject !== null && pObject !== undefined) {
        console[debugType](this.classname, pMessage, pObject, timestr);
      } else {
        console[debugType](this.classname, pMessage, timestr);
      }
    }
  }

  checkForConsole(): boolean {
    this.blnHasConsole = true;
    try {
      console.log();
    } catch (er) {
      this.blnHasConsole = false;
    }
    return this.blnHasConsole;
  }
}
